import type { PropsWithChildren } from 'react';
import React from 'react';
import cn from 'classnames';
import * as styles from './styles.module.css';

export function BlockContainer({
  children,
  className = '',
}: PropsWithChildren<{ className?: string }>) {
  return <section className={cn([styles.blockContainer, className])}>{children}</section>;
}
